import { FitTextModule, ButtonModule, FormFieldModule} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NeurobicCorrectAnswerPreviewComponent } from './neurobic-preview/neurobic-answer-preview/neurobic-answer-preview.component';
import { NeurobicControllerComponent } from './neurobic-controller/neurobic-controller.component';
import { NeurobicExamplePreviewComponent } from './neurobic-preview/neurobic-example-preview/neurobic-example-preview.component';
import { NeurobicParametersPreviewComponent } from './neurobic-preview/neurobic-parameters-preview/neurobic-parameters-preview.component';
import { NeurobicSettingsComponent } from './neurobic-settings/neurobic-settings.component';
import { NeurobicUserAnswerPreviewComponent } from './neurobic-preview/neurobic-user-answer-preview/neurobic-user-answer-preview.component';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';

@NgModule({
  declarations: [
    NeurobicControllerComponent,
    NeurobicSettingsComponent,
    NeurobicCorrectAnswerPreviewComponent,
    NeurobicExamplePreviewComponent,
    NeurobicParametersPreviewComponent,
    NeurobicUserAnswerPreviewComponent,
  ],
  exports: [
    NeurobicControllerComponent,
    NeurobicSettingsComponent,
    NeurobicCorrectAnswerPreviewComponent,
    NeurobicExamplePreviewComponent,
    NeurobicParametersPreviewComponent,
    NeurobicUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FitTextModule,
    GamesSharedModule,
    FormFieldModule,
  ],
})
export class NeurobicModule {}
